const quizActions = {
  // action hooks for quiz events
  'QUIZ/LOBBY_SCREEN': async () => { },
  'QUIZ/START_QUIZ': async () => { },
  'QUIZ/SHOW_QUESTION_NUMBER': async () => { },
  'QUIZ/COUNTDOWN_TO_SHOW_QUESTION': async () => { },
  'QUIZ/SHOW_QUESTION': async () => { },
  'QUIZ/CLOCK_TICK': async () => { },
  'QUIZ/COUNTDOWN_TO_END_QUESTION': async () => { },
  'QUIZ/TIMES_UP': async () => { },
  'QUIZ/REVEAL_ANSWER': async () => { },
  'QUIZ/LEADERBOARD': async () => { },
}

export default quizActions
